module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00085.37f9cd4c.jpg";